import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  quote: string;
  product?: string;
}
export function TestimonialCard({
  initials,
  name,
  location,
  quote,
  product
}: TestimonialProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="bg-brand-black border border-gray-800 rounded-2xl p-6 md:p-8 flex flex-col h-full hover:border-brand-green/30 transition-colors" data-id="element-241">
      <div className="flex items-center gap-4 mb-6" data-id="element-242">
        <div className="w-12 h-12 rounded-full bg-brand-dark border border-brand-green/30 flex items-center justify-center text-brand-light font-bold text-lg" data-id="element-243">
          {initials}
        </div>
        <div data-id="element-244">
          <div className="font-bold text-white" data-id="element-245">{name}</div>
          <div className="text-sm text-gray-400" data-id="element-246">{location}</div>
        </div>
      </div>

      <div className="flex gap-1 mb-4" data-id="element-247">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-brand-gold fill-brand-gold" data-id="element-248" />)}
      </div>

      <p className="text-gray-300 italic flex-grow" data-id="element-249">"{quote}"</p>

      {product && <div className="mt-6 pt-4 border-t border-gray-800 text-xs text-brand-light font-medium" data-id="element-250">
          Compró: {product}
        </div>}
    </motion.div>;
}
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'MR',
    name: 'Marta R.',
    location: 'Buenos Aires',
    quote: '4 años con omeprazol. A los 12 días el ardor bajó a la mitad. No lo podía creer.'
  }, {
    initials: 'GS',
    name: 'Gloria S.',
    location: 'Córdoba',
    quote: 'Todo lo conseguí en el super de mi barrio. Sin productos raros ni fortunas.'
  }, {
    initials: 'NP',
    name: 'Norma P.',
    location: 'Rosario',
    quote: 'El cronograma de 30 días fue lo que me faltaba. Mi estómago finalmente respondió.'
  }];
  return <section className="py-20 bg-brand-dark" data-id="element-251">
      <div className="container mx-auto px-4" data-id="element-252">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-253">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-254" />)}
        </div>
      </div>
    </section>;
}